import { render, staticRenderFns } from "./ImageVector.vue?vue&type=template&id=04292214&scoped=true&"
import script from "./ImageVector.vue?vue&type=script&lang=js&"
export * from "./ImageVector.vue?vue&type=script&lang=js&"
import style0 from "./ImageVector.vue?vue&type=style&index=0&id=04292214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04292214",
  null
  
)

export default component.exports